import { nameof } from "ts-simple-nameof";
import * as yup from "yup";
import type { GeneralParamsDto } from "../dtos";

export const GeneralParamsValidationRuleObject = {
  [nameof<GeneralParamsDto>((x) => x.contractReplacementNumber)]: yup
    .string()
    .test(
      "no-whitespace",
      "Vyplňte číslo smlouvy",
      (value: string | undefined) => !value || !!value.trim()
    )
    .test(
      "should-not-contain-whitespace",
      "Číslo smlouvy nesmí obsahovat mezery.",
      (value: string | undefined) => !value || !value.match(/\s/)
    )
    .nullable(),
  // SPOL
  [nameof<GeneralParamsDto>((x) => x.contractReplacementInsurerId)]: yup
    .number()
    .when(
      nameof<GeneralParamsDto>((x) => x.contractReplacementNumber),
      {
        is: (contractReplacementNumber?: string) => !!contractReplacementNumber,
        then: () =>
          yup
            .number()
            .nullable()
            .required("Vyberte pojišťovnu nahrazující smlouvy"),
        otherwise: () => yup.number().nullable().optional(),
      }
    )
};


export const GeneralParamsPublicPoleasValidationRuleObject = {
  [nameof<GeneralParamsDto>((x) => x.paramsDataValid)]: yup
    .boolean()
    .required('Vyberte, zda jsou všechny údaje správné'),

  [nameof<GeneralParamsDto>((x) => x.paramasDisagreements)]: yup
    .string()
    .when(nameof<GeneralParamsDto>((x) => x.paramsDataValid), {
      is: false,
      then: schema => schema.required('Vyplňte nesrovnalosti v uvedených údajích'),
      otherwise: schema => schema.notRequired(),
    }),

  [nameof<GeneralParamsDto>((x) => x.insuranceStartDate)]: yup
    .date()
    .transform((value, originalValue) => {
      return originalValue === '' ? null : value;
    })
    .typeError('Zadejte platné datum počátku pojištění')
    .required('Zadejte datum počátku pojištění'),
};

export const GeneralParamsValidationSchema = yup.object().shape(GeneralParamsValidationRuleObject) as any
export const GeneralParamsPublicPoleasValidationSchema = yup.object().shape(GeneralParamsPublicPoleasValidationRuleObject) as any
